module.exports = __webpack_public_path__ + "static/f-icon1-502a26bf4d4228d5c02cb7c24fe49cd7.svg";